module.exports = __webpack_public_path__ + "static/media/section-6-3.239e0caf.svg";